import type { Program } from '@/data/hooks/usePrograms';

export type UrgencyTier = 'expired' | 'final' | 'soon' | 'ok' | 'none';

export function daysUntilExpiry(p: Pick<Program, 'expiry_date'>): number | null {
  if (!p.expiry_date) return null;
  const exp = new Date(p.expiry_date).getTime();
  return Math.ceil((exp - Date.now()) / 86400000);
}

export function urgencyTier(p: Pick<Program, 'expiry_date'>): UrgencyTier {
  const d = daysUntilExpiry(p);
  if (d === null) return 'none';
  if (d < 0) return 'expired';
  if (d <= 3) return 'final';
  if (d <= 14) return 'soon';
  return 'ok';
}

export function countdownLabel(p: Pick<Program, 'expiry_date'>): string | null {
  const d = daysUntilExpiry(p);
  if (d === null) return null;
  if (d < 0) return `Expired ${Math.abs(d)}d ago`;
  if (d === 0) return 'Ends today';
  if (d === 1) return 'Ends tomorrow';
  return `Ends in ${d}d`;
}